/**
 * Path Layer A inventory (GET). Layer B gaps (POST). Presence stays free.
 */
import { api } from './client';

const unwrap = (res) => (res?.data?.data ?? res?.data ?? res);

export async function getStoryPath(storyId) {
  return unwrap(await api.get(`/stories/${storyId}/path`));
}

export async function getStoryPathGaps(storyId) {
  return unwrap(await api.post(`/stories/${storyId}/path/gaps`));
}

export const pathApi = {
  get: getStoryPath,
  getGaps: getStoryPathGaps,
};
